import { createAction } from '@reduxjs/toolkit';

export const GET_PAGINATED_LISTS = 'GET_PAGINATED_LISTS';
export const GETTING_PAGINATED_LISTS_SUCCEEDED =
  'GETTING_PAGINATED_LISTS_SUCCEEDED';
export const GETTING_PAGINATED_LISTS_FAILED = 'GETTING_PAGINATED_LISTS_FAILED';
export const GET_LIST = 'GET_LIST';
export const GETTING_LIST_SUCCEEDED = 'GETTING_LIST_SUCCEEDED';
export const GETTING_LIST_FAILED = 'GETTING_LIST_FAILED';
export const DELETE_LIST = 'DELETE_LIST';
export const DELETING_LIST_SUCCEEDED = 'DELETING_LIST_SUCCEEDED';
export const DELETING_LIST_FAILED = 'DELETING_LIST_FAILED';
export const UPDATE_LIST_NAME = 'UPDATE_LIST_NAME';
export const UPDATING_LIST_NAME_SUCCEEDED = 'UPDATING_LIST_NAME_SUCCEEDED';
export const UPDATING_LIST_NAME_FAILED = 'UPDATING_LIST_NAME_FAILED';
export const CREATE_LIST = 'CREATE_LIST';
export const CREATING_LIST_SUCCEEDED = 'CREATING_LIST_SUCCEEDED';
export const CREATING_LIST_FAILED = 'CREATING_LIST_FAILED';
export const GET_ACTIVE_SUBSCRIBERS = 'GET_ACTIVE_SUBSCRIBERS';
export const GETTING_ACTIVE_SUBSCRIBERS_SUCCEEDED =
  'GETTING_ACTIVE_SUBSCRIBERS_SUCCEEDED';
export const GETTING_ACTIVE_SUBSCRIBERS_FAILED =
  'GETTING_ACTIVE_SUBSCRIBERS_FAILED';
export const CREATE_SUBSCRIBER_LIST = 'CREATE_SUBSCRIBER_LIST';
export const CREATING_SUBSCRIBER_LIST_SUCCEEDED = 
  'CREATING_SUBSCRIBER_LIST_SUCCEEDED';
export const CREATING_SUBSCRIBER_LIST_FAILED =
  'CREATING_SUBSCRIBER_LIST_FAILED';
export const UPDATE_SUBSCRIBER_LIST = 'UPDATE_SUBSCRIBER_LIST';
export const UPDATING_SUBSCRIBER_LIST_SUCCEEDED =
  'UPDATING_SUBSCRIBER_LIST_SUCCEEDED';
export const UPDATING_SUBSCRIBER_LIST_FAILED =
  'UPDATING_SUBSCRIBER_LIST_FAILED';
export const GET_ADDITIONAL_PROFILE_LIST = 'GET_ADDITIONAL_PROFILE_LIST';
export const GETTING_ADDITIONAL_PROFILE_LIST_SUCCEEDED =
  'GETTING_ADDITIONAL_PROFILE_LIST_SUCCEEDED';
export const GETTING_ADDITIONAL_PROFILE_LIST_FAILED =
  'GETTING_ADDITIONAL_PROFILE_LIST_FAILED';
export const GET_SUPPRESSED_SUBSCRIBERS = 'GET_SUPPRESSED_SUBSCRIBERS';
export const GETTING_SUPPRESSED_SUBSCRIBERS_SUCCEEDED =
  'GETTING_SUPPRESSED_SUBSCRIBERS_SUCCEEDED';
export const GETTING_SUPPRESSED_SUBSCRIBERS_FAILED =
  'GETTING_SUPPRESSED_SUBSCRIBERS_FAILED';
export const ACTIVATE_SUBSCRIBER = 'ACTIVATE_SUBSCRIBER';
export const ACTIVATE_SUBSCRIBER_SUCCEEDED = 'ACTIVATE_SUBSCRIBER_SUCCEEDED';
export const ACTIVATE_SUBSCRIBER_FAILED = 'ACTIVATE_SUBSCRIBER_FAILED';
export const SUPPRESS_SUBSCRIBER = 'SUPPRESS_SUBSCRIBER';
export const SUPPRESS_SUBSCRIBER_SUCCEEDED = 'SUPPRESS_SUBSCRIBER_SUCCEEDED';
export const SUPPRESS_SUBSCRIBER_FAILED = 'SUPPRESS_SUBSCRIBER_FAILED';
export const REMOVE_SUBSCRIBER = 'REMOVE_SUBSCRIBER';
export const REMOVING_SUBSCRIBER_SUCCEEDED = 'REMOVING_SUBSCRIBER_SUCCEEDED';
export const REMOVING_SUBSCRIBER_FAILED = 'REMOVING_SUBSCRIBER_FAILED';
export const IMPORT_FILE = 'IMPORT_FILE';
export const IMPORT_FILE_SUCCEEDED = 'IMPORT_FILE_SUCCEEDED';
export const IMPORT_FILE_FAILED = 'IMPORT_FILE_FAILED';
export const GET_SAMPLE_FILE = 'GET_SAMPLE_FILE';
export const GETTING_SAMPLE_FILE_SUCCEEDED = 'GETTING_SAMPLE_FILE_SUCCEEDED';
export const GETTING_SAMPLE_FILE_FAILED = 'GETTING_SAMPLE_FILE_FAILED';
export const DOWNLOADED_SAMPLE_FILE = 'DOWNLOADED_SAMPLE_FILE';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';
export const GET_PAGINATED_SEGMENTED_LISTS = 'GET_PAGINATED_SEGMENTED_LISTS';
export const GETTING_PAGINATED_SEGMENTED_LISTS_SUCCEEDED =
  'GETTING_PAGINATED_SEGMENTED_LISTS_SUCCEEDED';
export const GETTING_PAGINATED_SEGMENTED_LISTS_FAILED =
  'GETTING_PAGINATED_SEGMENTED_LISTS_FAILED';
export const GET_SEGMENTED_LIST = 'GET_SEGMENTED_LIST';
export const GETTING_SEGMENTED_LIST_SUCCEEDED =
  'GETTING_SEGMENTED_LIST_SUCCEEDED';
export const GETTING_SEGMENTED_LIST_FAILED = 'GETTING_SEGMENTED_LIST_FAILED';
export const CREATE_SEGMENTED_LIST = 'CREATE_SEGMENTED_LIST';
export const CREATING_SEGMENTED_LIST_SUCCEEDED =
  'CREATING_SEGMENTED_LIST_SUCCEEDED';
export const CREATING_SEGMENTED_LIST_FAILED = 'CREATING_SEGMENTED_LIST_FAILED';
export const UPDATE_SEGMENTED_LIST = 'UPDATE_SEGMENTED_LIST';
export const UPDATING_SEGMENTED_LIST_SUCCEEDED =
  'UPDATING_SEGMENTED_LIST_SUCCEEDED';
export const UPDATING_SEGMENTED_LIST_FAILED = 'UPDATING_SEGMENTED_LIST_FAILED';
export const DELETE_SEGMENTED_LIST = 'DELETE_SEGMENTED_LIST';
export const DELETING_SEGMENTED_LIST_SUCCEEDED =
  'DELETING_SEGMENTED_LIST_SUCCEEDED';
export const DELETING_SEGMENTED_LIST_FAILED = 'DELETING_SEGMENTED_LIST_FAILED';
export const GET_IMPORT_STATUS_LIST = 'GET_IMPORT_STATUS_LIST';
export const GETTING_IMPORT_STATUS_LIST_SUCCEEDED =
  'GETTING_IMPORT_STATUS_LIST_SUCCEEDED';
export const GETTING_IMPORT_STATUS_LIST_FAILED =
  'GETTING_IMPORT_STATUS_LIST_FAILED';
export const GET_ERROR_FILE = 'GET_ERROR_FILE';
export const GETTING_ERROR_FILE_SUCCEEDED = 'GETTING_ERROR_FILE_SUCCEEDED';
export const GETTING_ERROR_FILE_FAILED = 'GETTING_ERROR_FILE_FAILED';
export const DOWNLOADED_ERROR_FILE = 'DOWNLOADED_ERROR_FILE';
export const GET_FILE_NAME_IMPORT_STATUS = 'GET_FILE_NAME_IMPORT_STATUS';
export const GETTING_FILE_NAME_IMPORT_STATUS_SUCCEEDED =
  'GETTING_FILE_NAME_IMPORT_STATUS_SUCCEEDED';
export const GETTING_FILE_NAME_IMPORT_STATUS_FAILED =
  'GETTING_FILE_NAME_IMPORT_STATUS_FAILED';
export const RESET_GET_FILE_NAME_STATUS = 'RESET_GET_FILE_NAME_STATUS';
export const SET_CURRENT_LIST = 'SET_CURRENT_LIST';
export const RESET_IMPORT_SUCCEEDED = 'RESET_IMPORT_SUCCEEDED';
export const CLEAR_LIST_STORE = 'CLEAR_LIST_STORE';
export const GET_ALL_LISTS = 'GET_ALL_LISTS';
export const GETTING_ALL_LISTS_SUCCEEDED = 'GETTING_ALL_LISTS_SUCCEEDED';
export const GETTING_ALL_LISTS_FAILED = 'GETTING_ALL_LISTS_FAILED';
export const GET_ALL_SEGMENTED_LISTS = 'GET_ALL_SEGMENTED_LISTS';
export const GETTING_ALL_SEGMENTED_LISTS_SUCCEEDED =
  'GETTING_ALL_SEGMENTED_LISTS_SUCCEEDED';
export const GETTING_ALL_SEGMENTED_LISTS_FAILED =
  'GETTING_ALL_SEGMENTED_LISTS_FAILED';
export const RESET_LISTS_DATA = 'RESET_LISTS_DATA';
export const DELETE_ALL_SUBSCRIBERS = 'DELETE_ALL_SUBSCRIBERS';
export const DELETING_ALL_SUBSCRIBERS_SUCCEEDED = 'DELETING_ALL_SUBSCRIBERS_SUCCEEDED';
export const DELETING_ALL_SUBSCRIBERS_FAILED = 'DELETING_ALL_SUBSCRIBERS_FAILED';

export const UPDATE_LIST_FILTERS = 'UPDATE_LIST_FILTERS';
export const RESET_LIST_FILTERS = 'RESET_LIST_FILTERS';

export const getPaginatedLists = createAction(GET_PAGINATED_LISTS);
export const gettingPaginatedListsSucceeded = createAction(
  GETTING_PAGINATED_LISTS_SUCCEEDED
);
export const gettingPaginatedListsFailed = createAction(
  GETTING_PAGINATED_LISTS_FAILED
);
export const getList = createAction(GET_LIST);
export const gettingListSucceeded = createAction(GETTING_LIST_SUCCEEDED);
export const gettingListFailed = createAction(GETTING_LIST_FAILED);
export const deleteList = createAction(DELETE_LIST);
export const deletingListSucceeded = createAction(DELETING_LIST_SUCCEEDED);
export const deletingListFailed = createAction(DELETING_LIST_FAILED);
export const updateListName = createAction(UPDATE_LIST_NAME);
export const updatingListNameSucceeded = createAction(
  UPDATING_LIST_NAME_SUCCEEDED
);
export const updatingListNameFailed = createAction(UPDATING_LIST_NAME_FAILED);
export const createList = createAction(CREATE_LIST);
export const creatingListSucceeded = createAction(CREATING_LIST_SUCCEEDED);
export const creatingListFailed = createAction(CREATING_LIST_FAILED);
export const getActiveSubscribers = createAction(GET_ACTIVE_SUBSCRIBERS);
export const gettingActiveSubscribersSucceeded = createAction(
  GETTING_ACTIVE_SUBSCRIBERS_SUCCEEDED
);
export const gettingActiveSubscribersFailed = createAction(
  GETTING_ACTIVE_SUBSCRIBERS_FAILED
);
export const createSubscriberList = createAction(CREATE_SUBSCRIBER_LIST);
export const creatingSubscriberListSucceeded = createAction(
  CREATING_SUBSCRIBER_LIST_SUCCEEDED
);
export const creatingSubscriberListFailed = createAction(
  CREATING_SUBSCRIBER_LIST_FAILED
);
export const updateSubscriberList = createAction(UPDATE_SUBSCRIBER_LIST);
export const updatingSubscriberListSucceeded = createAction(
  UPDATING_SUBSCRIBER_LIST_SUCCEEDED
);
export const updatingSubscriberListFailed = createAction(
  UPDATING_SUBSCRIBER_LIST_FAILED
);
export const getAdditionalProfileList = createAction(GET_ADDITIONAL_PROFILE_LIST);
export const gettingAdditionalProfileListSucceeded = createAction(
  GETTING_ADDITIONAL_PROFILE_LIST_SUCCEEDED
);
export const gettingAdditionalProfileListFailed = createAction(
  GETTING_ADDITIONAL_PROFILE_LIST_FAILED
);
export const getSuppressedSubscribers = createAction(
  GET_SUPPRESSED_SUBSCRIBERS
);
export const gettingSuppressedSubscribersSucceeded = createAction(
  GETTING_SUPPRESSED_SUBSCRIBERS_SUCCEEDED
);
export const gettingSuppressedSubscribersFailed = createAction(
  GETTING_SUPPRESSED_SUBSCRIBERS_FAILED
);
export const activateSubscriber = createAction(ACTIVATE_SUBSCRIBER);
export const activateSubscriberSucceeded = createAction(
  ACTIVATE_SUBSCRIBER_SUCCEEDED
);
export const activateSubscriberFailed = createAction(
  ACTIVATE_SUBSCRIBER_FAILED
);
export const suppressSubscriber = createAction(SUPPRESS_SUBSCRIBER);
export const suppressSubscriberSucceeded = createAction(
  SUPPRESS_SUBSCRIBER_SUCCEEDED
);
export const suppressSubscriberFailed = createAction(
  SUPPRESS_SUBSCRIBER_FAILED
);
export const removeSubscriber = createAction(REMOVE_SUBSCRIBER);
export const removeSubscriberSucceeded = createAction(
  REMOVING_SUBSCRIBER_SUCCEEDED
);
export const removeSubscriberFailed = createAction(REMOVING_SUBSCRIBER_FAILED);
export const importFile = createAction(IMPORT_FILE);
export const importFileSucceeded = createAction(IMPORT_FILE_SUCCEEDED);
export const importFileFailed = createAction(IMPORT_FILE_FAILED);
export const getSampleFile = createAction(GET_SAMPLE_FILE);
export const gettingSampleFileSucceeded = createAction(
  GETTING_SAMPLE_FILE_SUCCEEDED
);
export const gettingSampleFileFailed = createAction(GETTING_SAMPLE_FILE_FAILED);
export const downloadedSampleFile = createAction(DOWNLOADED_SAMPLE_FILE);
export const resetSnackbar = createAction(RESET_SNACKBAR);
export const getPaginatedSegmentedLists = createAction(
  GET_PAGINATED_SEGMENTED_LISTS
);
export const gettingPaginatedSegmentedListsSucceeded = createAction(
  GETTING_PAGINATED_SEGMENTED_LISTS_SUCCEEDED
);
export const gettingPaginatedSegmentedListsFailed = createAction(
  GETTING_PAGINATED_SEGMENTED_LISTS_FAILED
);
export const getSegmentedList = createAction(GET_SEGMENTED_LIST);
export const gettingSegmentedListSucceeded = createAction(
  GETTING_SEGMENTED_LIST_SUCCEEDED
);
export const gettingSegmentedListFailed = createAction(
  GETTING_SEGMENTED_LIST_FAILED
);
export const createSegmentedList = createAction(CREATE_SEGMENTED_LIST);
export const creatingSegmentedListSucceeded = createAction(
  CREATING_SEGMENTED_LIST_SUCCEEDED
);
export const creatingSegmentedListFailed = createAction(
  CREATING_SEGMENTED_LIST_FAILED
);
export const updateSegmentedList = createAction(UPDATE_SEGMENTED_LIST);
export const updatingSegmentedListSucceeded = createAction(
  UPDATING_SEGMENTED_LIST_SUCCEEDED
);
export const updatingSegmentedListFailed = createAction(
  UPDATING_SEGMENTED_LIST_FAILED
);
export const deleteSegmentedList = createAction(DELETE_SEGMENTED_LIST);
export const deletingSegmentedListSucceeded = createAction(
  DELETING_SEGMENTED_LIST_SUCCEEDED
);
export const deletingSegmentedListFailed = createAction(
  DELETING_SEGMENTED_LIST_FAILED
);
export const getImportStatusList = createAction(GET_IMPORT_STATUS_LIST);
export const gettingImportStatusListSucceeded = createAction(
  GETTING_IMPORT_STATUS_LIST_SUCCEEDED
);
export const gettingImportStatusListFailed = createAction(
  GETTING_IMPORT_STATUS_LIST_FAILED
);
export const getErrorFile = createAction(GET_ERROR_FILE);
export const gettingErrorFileSucceeded = createAction(
  GETTING_ERROR_FILE_SUCCEEDED
);
export const gettingErrorFileFailed = createAction(GETTING_ERROR_FILE_FAILED);
export const downloadedErrorFile = createAction(DOWNLOADED_ERROR_FILE);
export const getFileNameImportStatus = createAction(
  GET_FILE_NAME_IMPORT_STATUS
);
export const gettingFileNameImportStatusSucceeded = createAction(
  GETTING_FILE_NAME_IMPORT_STATUS_SUCCEEDED
);
export const gettingFileNameImportStatusFailed = createAction(
  GETTING_FILE_NAME_IMPORT_STATUS_FAILED
);
export const resetGetFileNameStatus = createAction(RESET_GET_FILE_NAME_STATUS);
export const setCurrentList = createAction(SET_CURRENT_LIST);
export const resetImportSucceeded = createAction(RESET_IMPORT_SUCCEEDED);
export const clearListStore = createAction(CLEAR_LIST_STORE);
export const getAllLists = createAction(GET_ALL_LISTS);
export const gettingAllListsSucceeded = createAction(
  GETTING_ALL_LISTS_SUCCEEDED
);
export const gettingAllListsFailed = createAction(GETTING_ALL_LISTS_FAILED);
export const getAllSegmentedLists = createAction(GET_ALL_SEGMENTED_LISTS);
export const gettingAllSegmentedListsSucceeded = createAction(
  GETTING_ALL_SEGMENTED_LISTS_SUCCEEDED
);
export const gettingAllSegmentedListsFailed = createAction(
  GETTING_ALL_SEGMENTED_LISTS_FAILED
);
export const resetListsData = createAction(RESET_LISTS_DATA);
export const deleteAllSubscribers = createAction(DELETE_ALL_SUBSCRIBERS);
export const deletingAllSubscribersSucceeded = createAction(
  DELETING_ALL_SUBSCRIBERS_SUCCEEDED
);
export const deletingAllSubscribersFailed = createAction(
  DELETING_ALL_SUBSCRIBERS_FAILED
);

export const updateListFilters = createAction(UPDATE_LIST_FILTERS);
export const resetListFilters = createAction(RESET_LIST_FILTERS);